import React, { ReactNode } from "react";
import GuestNavbar from "../navbars/GuestNavbar";

const GuestLayout = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <GuestNavbar />
      {children}
    </>
  );
};

export default GuestLayout;
